import type { DateTime } from "luxon";
import { useCallback } from "react";
import { getShiftTypeByShiftTimes } from "../../utils/utilFunctions";
import { useWeekViewContext } from "./WeekViewContext";

type ShiftTimes = { startTime: DateTime; endTime: DateTime };

/** The Day view's week, for its edits; the page renders only once that week holds the day, so it's always there. */
export const useDayWeek = (date: DateTime) => {
	const { weekOfDate } = useWeekViewContext();

	const dayWeek = useCallback(() => {
		const found = weekOfDate(date);
		if (!found) throw new Error(`The week of ${date.toISODate()} isn't loaded`);
		return found;
	}, [weekOfDate, date]);

	/** The shift type a shift with these times goes in: the start-hour guess among the week's shift types. */
	const shiftTypeOfTimes = useCallback(
		(times: ShiftTimes) =>
			getShiftTypeByShiftTimes(
				dayWeek().week.weeklyShifts.map((row) => row.type),
				times,
			),
		[dayWeek],
	);

	return { dayWeek, shiftTypeOfTimes };
};
